import { useTranslation } from 'react-i18next';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useNavigate, useParams } from 'react-router-dom';

import { BodyWrapper, Header, MainWrapper, MenuForm } from '@components';
import { linklistMutation, siteQuery } from '@queries';
import SiteSidebar from '../components/SiteSidebar/SiteSidebar.jsx';
import { SiteBreadcrumbs } from '../components/SiteBreadcrumbs/SiteBreadcrumbs.jsx';

export const SiteAddMenu = () => {
  const { t, i18n } = useTranslation();
  const { siteID } = useParams();
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  console.log('here');
  // get site/template
  const { data: siteData, isPending: siteIsPending } = useQuery(
    siteQuery(siteID),
  );

  // save datamodel
  const mutation = useMutation(
    linklistMutation(null, {
      onSuccess: (data) => {
        console.log({ data });
        // invalidate the linklists list so it is fetched again
        queryClient.invalidateQueries({ queryKey: ['linklists', 'list'] });
        // navigate to the edit view
        navigate(`/dashboard/sites/${siteID}/menus/${data.id}`);
      },
    }),
  );

  return (
    <>
      <Header />
      <BodyWrapper>
        <SiteSidebar siteID={siteID} siteData={siteData} />
        <MainWrapper>
          <SiteBreadcrumbs siteData={siteData}>
            <li className="sb-flex">
              <span>{t('Menus')}</span>
            </li>
          </SiteBreadcrumbs>
          <div className="sb-manage-content">
            <div className="sb-manage-content-head">
              <h1>{t('Add')}</h1>
            </div>
            <MenuForm
              disabled={mutation.isPending}
              mutation={mutation}
              onCancel={() => {
                navigate(`/dashboard/sites/${siteID}/menus`);
              }}
              siteID={siteID}
            />
          </div>
        </MainWrapper>
      </BodyWrapper>
    </>
  );
};
